<template>
  <div class="details-container h-100">
    <div class="details-table-container" :style="!selectedRow ? { height: '100%' } : {}" :class="selectedRow ? 'h-65' : 'h-100'">
      <a-spin :spinning="loading">
        <a-icon slot="indicator" type="loading" style="font-size: 48px" spin />
        <DetailTable />
      </a-spin>
    </div>
    <div class="note-container h-35 scroll" :class="{ 'display-none': !selectedRow}">
      <a-row type="flex" class="h-15" align="middle">
        <a-col :span="24">
          <p class="note-title no-margin">Notes de l'enseignant : </p>
        </a-col>
      </a-row>
      <template v-if="selectedRow.numero === ongoingAlteredRow.numero && ongoingAlteredRow.remediable">
        <a-row type="flex" class="h-15" align="middle">
          <a-col class="note-spacing" :span="1">
            <a-icon class="font-size-20" type="exclamation-circle" />
          </a-col>
          <a-col :span="23">
            <p class="no-margin font-size-17">Demande de correction par {{ ongoingAlteredRow.loginCorrecteur }} le {{ ongoingAlteredRow.dateRemediation }} à {{ ongoingAlteredRow.heureRemediation }}</p>
          </a-col>
        </a-row>
        <a-row type="flex" class="h-15" align="top">
          <a-col class="note-spacing" :span="1">
            <a-icon class="font-size-20" type="form" />
          </a-col>
          <a-col :span="23">
            <p class="font-size-17">Remarque :</p>
          </a-col>
        </a-row>
        <a-row type="flex" class="comment-container" align="top">
          <a-col :span="23">
            <a-textarea
              autoFocus
              id="remediation"
              :defaultValue="selectedRow.remarque"
              :value="ongoingAlteredRow.remarque"
              placeholder="Rentrez un commentaire ici"
              :autosize="{ minRows: 2, maxRows: 6 }"
              @change="e => handleChangeCommentField(e.target.value)"
              @keyup.esc="() => handleCancelCommenting()" />
          </a-col>
          <a-col :span="1">
            <a-tooltip placement="top" >
              <template slot="title">
                <span>Sauvegarder les modifications</span>
              </template>
              <a-icon tabindex="0" class="control-icon font-size-20" type="save" @click="() => handleSaveComment(selectedRow.numero)" @keyup.enter="() => handleSaveComment(selectedRow.numero)" />
            </a-tooltip>
            <a-popconfirm title='Êtes-vous sûr ?' @confirm="() => handleCancelCommenting()" okText="Oui" cancelText="Annuler">
              <a-icon slot="icon" type="question-circle-o" />
              <a-tooltip placement="bottom" >
                <template slot="title">
                  <span>Annuler les modifications</span>
                </template>
                <a-icon class="control-icon font-size-20" type="stop" />
              </a-tooltip>
            </a-popconfirm>
            <a-popconfirm title='Êtes-vous sûr ?' @confirm="() => handleRemoveComment(selectedRow.numero)" okText="Oui" cancelText="Annuler">
              <a-icon slot="icon" type="question-circle-o" />
              <a-tooltip placement="bottom" >
                <template slot="title">
                  <span>Supprimer la remarque</span>
                </template>
                <a-icon class="control-icon font-size-20" type="close" />
              </a-tooltip>
            </a-popconfirm>
          </a-col>
        </a-row>
        <a-row type="flex" class="">
          <template v-for="comment in commentsData">
            <a-col class="note-spacing" :key="comment.numero">
              <CommentSuggestion @clicked="handleCommentSuggestionClick" :text="comment.remarque" />
            </a-col>
          </template>
        </a-row>
      </template>
      <template v-else-if="selectedRow.loginValidateur && !selectedRow.loginCorrecteur">
        <a-row type="flex" class="h-15" align="middle">
          <a-col class="note-spacing" :span="1">
            <a-icon class="font-size-20" type="check-circle" />
          </a-col>
          <a-col :span="23">
            <p class="no-margin font-size-17">Validé par <b>{{ selectedRow.loginValidateur }}</b> le {{ selectedRow.dateValidation }} à {{ selectedRow.heureValidation }}</p>
          </a-col>
        </a-row>
      </template>
      <template v-else-if="selectedRow.loginCorrecteur">
        <template v-if="selectedRow.loginValidateur">
          <a-row type="flex" class="h-15" align="middle">
            <a-col class="note-spacing" :span="1">
              <a-icon class="font-size-20" type="check-circle" />
            </a-col>
            <a-col :span="23">
              <p class="no-margin font-size-17">Validé par <b>{{ selectedRow.loginValidateur }}</b> le {{ selectedRow.dateValidation }} à {{ selectedRow.heureValidation }}</p>
            </a-col>
          </a-row>
          <a-row type="flex" class="h-15" align="middle">
            <a-col class="note-spacing" :span="1">
              <a-icon class="font-size-20" type="exclamation-circle" />
            </a-col>
            <a-col :span="23">
              <p class="no-margin font-size-17">Ce détail avait fait l'objet d'une remarque par <b>{{ selectedRow.loginCorrecteur }}</b> le {{ selectedRow.dateRemediation }} à {{ selectedRow.heureRemediation }}</p>
            </a-col>
          </a-row>
        </template>
        <template v-else>
          <a-row type="flex" class="h-15" align="middle">
            <a-col class="note-spacing" :span="1">
              <a-icon class="font-size-20" type="exclamation-circle" />
            </a-col>
            <a-col :span="23">
              <p class="no-margin font-size-17">Demande de correction par <b>{{ selectedRow.loginCorrecteur }}</b> le {{ selectedRow.dateRemediation }} à {{ selectedRow.heureRemediation }}</p>
            </a-col>
          </a-row>
        </template>
        <a-row type="flex" class="h-15" align="top" style="margin-top: 10px;">
          <a-col class="note-spacing" :span="1">
            <a-icon class="font-size-20" type="form" />
          </a-col>
          <a-col :span="23">
            <p class="font-size-17"><u>Remarque :</u></p>
          </a-col>
        </a-row>
        <a-row type="flex" class="h-55 comment-container scroll" align="top">
          <a-col :span="24">
            <p class="no-margin font-size-17"><pre class="white-space-pre-wrap">{{ selectedRow.remarque }}</pre></p>
          </a-col>
        </a-row>
      </template>
      <template v-else>
        <a-row type="flex" class="h-15" align="middle">
          <a-col class="note-spacing" :span="24">
            <p class="no-margin font-size-17">Rien à afficher pour l'instant</p>
          </a-col>
        </a-row>
      </template>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import DetailTable from '../components/detail/DetailTable'
import CommentSuggestion from '../components/detail/CommentSuggestion'
import DateService from '../services/date_service'
import DetailService from '../services/detail_service'
import CommentService from '../services/comment_service'

export default {
  name: 'Details',
  components: {
    DetailTable,
    CommentSuggestion
  },
  data () {
    return {
      commentsData: undefined
    }
  },
  methods: {
    moment,
    ...mapActions({
      'setOngoingAlteredRow': 'detail/setOngoingAlteredRow',
      'setSelectedRow': 'detail/setSelectedRow',
      'setLoading': 'detail/setLoading'
    }),
    handleChangeCommentField (comment) {
      this.ongoingAlteredRow.remarque = comment
    },
    handleCommentSuggestionClick (suggestion) {
      let element = document.getElementById('remediation')
      let cursorPosition = element.selectionStart
      let value = element.value
      let output = [value.slice(0, cursorPosition), suggestion, value.slice(cursorPosition)].join('') + ' '
      const newData = this.ongoingAlteredRow
      Object.assign(newData, { remarque: output })
      this.setOngoingAlteredRow(newData)
      element.focus()
    },
    async handleSaveComment (numero) {
      console.log('save comment')
      // Impossible de laisser le champs remarque vide
      if (!this.ongoingAlteredRow.remarque || !this.ongoingAlteredRow.remarque.match(/[a-z]/i)) {
        this.$message.error('Erreur de saisie de la remarque')
        return
      }
      // Remplacer la ligne numero de data par ongoingAlteredRow
      const newData = [...this.detailsData]
      const target = newData.filter(item => numero === item.numero)[0]
      if (target) {
        // préparation des paramètres
        let params = Object.assign({}, (({ numero, detail }) => ({ numero, detail }))(target))
        delete this.ongoingAlteredRow.remediable
        // Si le détail avait précédemment été validé, la validation saute
        this.ongoingAlteredRow.loginValidateur = null
        this.ongoingAlteredRow.dateValidation = null
        this.ongoingAlteredRow.heureValidation = null
        Object.assign(params, this.ongoingAlteredRow)
        params = DateService.formatObjectArrayDatesToDisplayFormat([params], 'database')[0]
        // api : modifier le détail
        const response = await DetailService.editDetail(params)
        if (response) {
          this.$message.success('Remarque enregistrée')
          Object.assign(target, this.ongoingAlteredRow)
          this.setOngoingAlteredRow(false)
        }
      }
    },
    handleCancelCommenting () {
      console.log('cancel comment')
      this.setOngoingAlteredRow(false)
    },
    async handleRemoveComment (numero) {
      console.log('remove comment')
      // Remplacer la ligne numero de data par ongoingAlteredRow
      const newData = [...this.detailsData]
      const target = newData.filter(item => numero === item.numero)[0]
      if (target) {
        // préparation des paramètres
        let params = Object.assign({}, (({ numero, detail }) => ({ numero, detail }))(target))
        let deletedField = {
          loginCorrecteur: null,
          dateRemediation: null,
          heureRemediation: null,
          remarque: null
        }
        Object.assign(params, deletedField)
        params = DateService.formatObjectArrayDatesToDisplayFormat([params], 'database')[0]
        // api : modifier le détail
        const response = await DetailService.editDetail(params)
        if (response) {
          this.$message.success('Remarque supprimée')
          Object.assign(target, params)
          this.setOngoingAlteredRow(false)
        }
      }
    }
  },
  computed: {
    ...mapState({
      darkTheme: state => state.darkTheme,
      selectedRow: state => state.detail.selectedRow,
      detailsData: state => state.detail.detailsData,
      ongoingAlteredRow: state => state.detail.ongoingAlteredRow,
      loading: state => state.detail.loading,
      user: state => state.auth.user,
      selectedWork: state => state.work.selectedWork
    })
  },
  async created () {
    document.title = `JT - Détails de ${this.selectedWork.titreTravail}`
    // Si user authentifié est enseignant, on fetch les remarques préformattées
    if (this.user.permissionLevel === 1) {
      const response = await CommentService.getComments()
      if (response) {
        const data = response.data.data
        this.commentsData = data.filter(x => x.positif === 0)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.save-comment-icon{
  cursor: pointer;
}
.comment-container{
  padding-left: 15px;
  padding-right: 15px;
}
.details-container{
  overflow: hidden;
}
.note-container{
  border-top: 1px solid lightgray;
}
.note-title{
  padding-left: 15px;
}
.note-spacing{
  padding-left: 15px;
}
</style>
